import {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import TiptapForm from "../../components/common/input-layout/tiptap/TiptapForm";
import {updateCADInfos} from "../../api/admin/cadReq";
import useAuth from "../../hooks/useAuth";
import FormButtons from "../../components/common/FormButtons";
import CADModalHelp from "../../pages/admin/CADModalHelp";
import {
    checkRequiredFields,
    getErrorListFromValidation,
    patternListChoices,
    removeErrorList,
    validateFormInput
} from "../../helper/tools";
import Icon from "../../components/common/Icon";

export default function FormCAD({ setShowModal, cadInfos, apiCadInfos }) {
    const { id } = useParams();
    const { auth } = useAuth();
    const token = auth.token;
    const [ values, setValues ] = useState();

    const onChange = (e) => {
        setValues({...values, [e.target.name]: e.target.value})
        validateFormInput(e)
    }

    const onChangeHtml = (e, inputName) => {
        setValues({...values, [inputName] : e})
        validateFormInput(e)
    }

    useEffect(() => {
        setValues(cadInfos)
    }, [ cadInfos ]);

    const handleRemoveModal = (e) => {
        setShowModal(false)
    }

    const handleSubmit= async (e) => {
        e.preventDefault();
        if (!checkRequiredFields()) {
            return;
        }
        let body = {
            id: parseInt(id),
            number: values?.number,
            name: values?.name,
            type: 1,
            category: values?.category,
            description: values?.description,
            additionalReferences: values?.additionalReferences,
            afterReferences: values?.afterReferences,
            content: values?.content,
            additionalAttachments: values?.additionalAttachments,
        }
        await updateCADInfos(token, body)
            .then((response) => {
                removeErrorList();
                if (!response?.response?.data?.error) {
                    setShowModal(false)
                    apiCadInfos()
                } else {
                    getErrorListFromValidation(response?.response?.data?.error)
                }
            })
    }

    const [ showHelpModal, setShowHelpModal ] = useState(false);

    const handleEmailHelpModal = () => {
        setShowHelpModal(true)
    }

    return (
        <form onSubmit={handleSubmit} method="POST" noValidate>
            <fieldset>
                {showHelpModal &&
                    <div className="modal cad-help">
                        <CADModalHelp cadName={cadInfos?.name} cadId={cadInfos?.number}
                                      setShowHelpModal={setShowHelpModal}
                                      legend="Aide sur les variables pour les courriers"/>
                    </div>
                }
                <Icon span="Informations d'un courrier" source="fa-solid fa-file-lines"/>
                <div className="form-input">
                    <label htmlFor="name">Nom du courrier</label>
                    <input pattern={patternListChoices?.name} name="name" type="text"
                           defaultValue={values?.name} onChange={onChange}/>
                </div>
                <div className="form-input html-textarea view">
                    <label>Description</label>
                    <TiptapForm content={values?.description} onChange={(e) => onChangeHtml(e, "description")}/>
                </div>
                <div className="form-input html-textarea view">
                    <label>Références complémentaires</label>
                    <TiptapForm content={values?.additionalReferences}
                                onChange={(e) => onChangeHtml(e, "additionalReferences")}/>
                </div>
                <div className="form-input html-textarea view">
                    <label>Sous références</label>
                    <TiptapForm content={values?.afterReferences}
                                onChange={(e) => onChangeHtml(e, "afterReferences")}/>
                </div>
                <button type="button" className="question"><i className="fa fa-question" onClick={handleEmailHelpModal}></i></button>
                <div className="form-input html-textarea view">
                    <label>Contenu</label>
                    <TiptapForm content={values?.content} onChange={(e) => onChangeHtml(e, "content")}/>
                </div>
                <div className="form-input html-textarea view">
                    <label>Pièces complémentaires</label>
                    <TiptapForm content={values?.additionalAttachments}
                                onChange={(e) => onChangeHtml(e, "additionalAttachments")}/>
                </div>
                <FormButtons handleRemoveModal={handleRemoveModal}/>
                <div className="errors"></div>
            </fieldset>
        </form>
    )
}
